import { useLayoutEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  GUARANTEE_QUILL_FORMATS,
  GUARANTEE_QUILL_MODULES,
  isEmptyRichText,
} from "../../utils/guaranteeRichText";

interface GuaranteeDescriptionEditorProps {
  value: string;
  onChange: (value: string) => void;
}

function GuaranteeDescriptionEditor({
  value,
  onChange,
}: GuaranteeDescriptionEditorProps) {
  const quillRef = useRef<ReactQuill>(null);

  useLayoutEffect(() => {
    const editor = quillRef.current?.getEditor();
    if (!editor || isEmptyRichText(value)) return;
    if (!isEmptyRichText(editor.root.innerHTML)) return;

    editor.clipboard.dangerouslyPasteHTML(value, "silent");
  }, [value]);

  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      defaultValue={value}
      onChange={(html, _delta, source) => {
        if (source !== "user") return;
        onChange(html);
      }}
      modules={GUARANTEE_QUILL_MODULES}
      formats={GUARANTEE_QUILL_FORMATS}
      placeholder="Descreva todos os benefícios e faça observações sobre o tipo de garantia."
    />
  );
}

export default GuaranteeDescriptionEditor;
